import { RelatedEntityTypeEnum } from '@/types/schema';

const ENTITY_TYPE_ENUM_MAP: Record<string, RelatedEntityTypeEnum> = {
  ['okr']: RelatedEntityTypeEnum.Okr,
  ['meetingInstance']: RelatedEntityTypeEnum.MeetingInstance,
  ['keyResult']: RelatedEntityTypeEnum.KeyResult,
  ['meeting']: RelatedEntityTypeEnum.Meeting,
  ['agendaItem']: RelatedEntityTypeEnum.AgendaItem,
};

export default ENTITY_TYPE_ENUM_MAP;
